import { GetKPIResponse } from '@/typings/services/kpi';
import axios from 'axios';

export function getKPIndexs() {
  return axios.get<GetKPIResponse>(`/kpi`, {
    params: { limit: 8 },
  });
}
